import {HttpClient} from "../requests";
import ENDPOINTS from "../endpoints";
import { TaxDriverConfigPaginator, TaxDriverConfigVersionPaginator } from "../../../models/driver-configs.dto";

export class DriverConfigs {
    getDriverConfigs = ( ) => HttpClient
        .get<TaxDriverConfigPaginator>(ENDPOINTS.DRIVER_CONFIG.GET);

    getDriverConfigsVersion = (countryCode: string) => HttpClient
        .get<TaxDriverConfigVersionPaginator>(ENDPOINTS.DRIVER_CONFIG.GET_DRIVER_VERSIONS.
            replace("{countryCode}", countryCode)
        );

}